<template>

    <div class="panel panel-clinic">

        <div class="panel-heading collapsed" href="#form_reports" data-toggle="collapse">

            <div class="arrow-down"></div>

            <h2 class="panel-title">Månadsredovisningar</h2>

        </div>

        <div id="form_reports" class="panel-collapse collapse">

            <div class="panel-body">

                <div class="list-no-hits" style="margin-top:40px; margin-bottom: 40px;" v-if="fetcher.loading">
                    Laddar...
                </div>

                <div class="list-no-hits" style="margin-top:40px; margin-bottom: 40px;" v-if="!fetcher.loading && periods.length === 0">
                    Denna massör ännu inga registrerade behandlingar.
                </div>

                <div class="panel panel-default" style="margin-bottom:20px;" v-for="period in periods">

                    <div class="panel-heading" v-bind:href="'#reports_'+period.year+''+period.month"
                         data-toggle="collapse">

                        <div class="row">

                            <div class="col-md-1">

                            </div>

                            <div class="col-md-9 col-xs-30">
                                {{ period.title }}
                            </div>

                            <div class="col-md-6 hidden-sm hidden-xs">
                                {{ (period.treatments.length + period.bonuses.length) }} st
                            </div>

                            <div class="col-md-9 hidden-sm hidden-xs">
                                Totalt {{ periodPayout(period, false) }} kr
                            </div>

                            <div class="col-md-10 col-xs-30">
                                {{ periodPayout(period, true) }} kr (ink moms)
                            </div>

                            <div class="col-md-6 hidden-sm hidden-xs">

                                <a v-bind:href="period.pdfLink" class="no-collapsable"
                                   v-if="period.status.status != 'new'" target="_blank">
                                    Ladda ner pdf
                                </a>

                            </div>
                            <div class="col-md-6 hidden-sm hidden-xs">

                                <span v-if="!period.status">Ej utbetald</span>

                                <span v-else>{{ period.status.paymentStatus.text }}</span>

                            </div>

                            <div class="col-md-2 hidden-sm hidden-xs">
                                <div class="arrow-down small"></div>
                            </div>

                        </div>

                    </div>

                    <div class="list-group collapse" v-bind:id="'reports_'+period.year+''+period.month">

                        <li class="list-group-item" v-for="treatment in period.treatments">
                            <div class="row">
                                <div class="col-md-1">
                                    <span v-if="treatment.metaData && treatment.metaData.is_manual">M</span>
                                </div>
                                <div class="col-md-9">
                                    {{ formatDate(treatment.treatment_at_normalized) }} <!-- format('Ymd H:i') -->
                                </div>
                                <div class="col-md-6">
                                    {{ treatment.duration_minutes }}
                                </div>
                                <div class="col-md-9">
                                    {{ treatment.payoutAmount }} kr
                                </div>
                                <div class="col-md-10">
                                    {{ treatment.payoutAmountIncVat }} kr (ink moms)
                                </div>
                                <div class="col-md-6">
                                    {{ treatment.onLocation }}
                                </div>
                                <div class="col-md-6">
                                    {{ treatment.customer_name }}
                                </div>
                            </div>
                        </li>

                        <li class="list-group-item" v-for="bonus in period.bonuses">
                            <div class="row">
                                <div class="col-md-1">

                                </div>
                                <div class="col-md-9">
                                    Övrigt
                                </div>
                                <div class="col-md-6">

                                </div>
                                <div class="col-md-9">
                                    {{ bonus.amount }} kr
                                </div>
                                <div class="col-md-10">
                                    {{ bonus.amountIncVat }} kr (ink moms)
                                </div>
                                <div class="col-md-12">
                                    {{ bonus.description }}
                                </div>
                            </div>
                        </li>

                    </div>

                </div>

            </div>

        </div>

    </div>

</template>

<script>

import mixin from './mixin'

import fetcher from '../../../shared/mixins/fetcher'

export default {

    mixins: [
        mixin,
        fetcher
    ],

    data () {
        return {
            periods: [],
            fetcher: {
                autoFill: [
                    'periods'
                ]
            }
        }
    },

    computed: {
        fetcherUrl () {
            return '/clinics/' + this.clinic.id + '/getPaymentPeriods'
        }
    },

    methods: {

        periodPayout (period, tax) {
            let sum = 0

            if (!tax) {
                sum += _.sumBy(period.treatments, 'payoutAmount')
                sum += _.sumBy(period.bonuses, 'amount')
            }
            if (tax) {
                sum += _.sumBy(period.treatments, 'payoutAmountIncVat')
                sum += _.sumBy(period.bonuses, 'amountIncVat')
            }

            return this.round(sum)
        },

        round (sum) {
            return _.round(sum, 1)
        },

        formatDate (date) {
            return moment(date).utc().format('YYYYMMDD HH:mm')
        }

    }

}

</script>
